// extracted by css-extract-rspack-plugin
export default {"menu":"i495cN","arrow":"TK8YoG"};